"use strict";

exports.__esModule = true;
exports.default = void 0;

var _addDays = _interopRequireDefault(require("date-fns/addDays"));

var _addMonths = _interopRequireDefault(require("date-fns/addMonths"));

var _addSeconds = _interopRequireDefault(require("date-fns/addSeconds"));

var _addYears = _interopRequireDefault(require("date-fns/addYears"));

var _compareAsc = _interopRequireDefault(require("date-fns/compareAsc"));

var _format = _interopRequireDefault(require("date-fns/format"));

var _isSameDay = _interopRequireDefault(require("date-fns/isSameDay"));

var _isSameMonth = _interopRequireDefault(require("date-fns/isSameMonth"));

var _isSameWeek = _interopRequireDefault(require("date-fns/isSameWeek"));

var _isValid = _interopRequireDefault(require("date-fns/isValid"));

var _parse = _interopRequireDefault(require("date-fns/parse"));

var _startOfMonth = _interopRequireDefault(require("date-fns/startOfMonth"));

var _startOfWeek = _interopRequireDefault(require("date-fns/startOfWeek"));

var _toDate = _interopRequireDefault(require("date-fns/toDate"));

var _locale = require("../locale");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var TIME_FORMAT = 'HH:mm:ss';

function getDaysOfMonth(dirtyDate) {
  var date = (0, _toDate.default)(dirtyDate);
  var current = (0, _startOfWeek.default)((0, _startOfMonth.default)(date), {
    weekStartsOn: (0, _locale.getLocale)('startOfWeek')
  });
  current.setHours(dirtyDate.getHours());
  current.setMinutes(dirtyDate.getMinutes());
  current.setSeconds(dirtyDate.getSeconds());
  var days = [];
  var index = 0;

  while (index < 42) {
    days.push(current);
    current = (0, _addDays.default)(current, 1);
    index += 1;
  }

  return days;
}

function isInvalid(date) {
  // eslint-disable-next-line
  return isNaN(date);
}

function toDateWithFormat(dirtyDate, fmt, def) {
  var date;
  if (typeof dirtyDate === 'string') date = (0, _parse.default)(dirtyDate, fmt, new Date(), {
    weekStartsOn: (0, _locale.getLocale)('startOfWeek')
  });else date = (0, _toDate.default)(dirtyDate);
  if (isInvalid(date)) date = (0, _toDate.default)(dirtyDate);
  if (isInvalid(date)) date = def;
  return date;
}

function compareMonth(dateLeft, dateRight, pad) {
  if (pad === void 0) {
    pad = 0;
  }

  if (!dateLeft || !dateRight) return 0;
  var left = new Date(dateLeft.getFullYear(), dateLeft.getMonth(), 1);
  var right = new Date(dateRight.getFullYear(), dateRight.getMonth() + pad, 1);
  return (0, _compareAsc.default)(left, right);
}

function newDate(defaultDate) {
  var date = defaultDate ? new Date(defaultDate) : new Date();
  return new Date(date.getFullYear(), date.getMonth(), date.getDate());
}

function setTime(date, old) {
  date.setHours(old.getHours());
  date.setMinutes(old.getMinutes());
  date.setSeconds(old.getSeconds());
  return date;
}

function cloneTime(date, old, fmt) {
  if (!date) return date;
  old = toDateWithFormat(old, fmt);
  if (isInvalid(old)) return date;
  return setTime(date, old);
}

function formatDateWithDefaultTime(date, value, defaultTime, fmt) {
  if (!date) return date;
  if (value) return setTime(date, value);
  if (!defaultTime) return date;
  var dateHMS = toDateWithFormat(defaultTime, TIME_FORMAT);
  if (isInvalid(dateHMS)) return date;
  var nDate = cloneTime(date, defaultTime, TIME_FORMAT);
  return (0, _format.default)(nDate, fmt);
}

function clearHMS(date) {
  if (!(0, _isValid.default)(date)) return date;
  return new Date(new Date(date.toDateString()).getTime());
}

function compareDateArray(arr1, arr2, type) {
  if (type === void 0) {
    type = 'date';
  }

  if (!arr1 || !arr2 || arr1.length !== arr2.length) return false;
  return arr1.every(function (v, i) {
    if (!v || !arr2[i]) return false;
    if (type === 'week') return (0, _format.default)(v, 'RRRR II') === (0, _format.default)(arr2[i], 'RRR II');
    return v.getTime() === arr2[i].getTime();
  });
}

function handleTimeDisabled(date, disabledTime) {
  if (typeof disabledTime === 'string') return (0, _format.default)(date, TIME_FORMAT) === disabledTime;
  if (typeof disabledTime === 'function') return disabledTime((0, _format.default)(date, TIME_FORMAT));
  return undefined;
}

function judgeTimeByRange() {
  for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
    args[_key] = arguments[_key];
  }

  var target = args[0],
      value = args[1],
      mode = args[2],
      min = args[3],
      max = args[4],
      range = args[5],
      disabled = args[6],
      disabledTime = args[7];
  var date = new Date(value.getTime());

  switch (mode) {
    case 'H':
      date.setHours(target);
      break;

    case 'h':
      if (date.getHours() >= 12) {
        date.setHours(target + 12);
        break;
      }

      date.setHours(target);
      break;

    case 'm':
    case 'minute':
      date.setMinutes(target);
      break;

    case 's':
    case 'second':
      date.setSeconds(target);
      break;

    case 'ampm':
      if (target === 0) {
        var hours = date.getHours();

        if (target === 1 && hours < 12) {
          date.setHours(hours + 12);
        } else if (target === 0 && hours >= 12) {
          date.setHours(hours - 12);
        }
      }

      break;

    default:
      break;
  }

  var isDisabled;
  if (disabled) isDisabled = disabled(date);
  if (disabledTime) isDisabled = isDisabled || handleTimeDisabled(date, disabledTime);
  if (isDisabled) return [true];

  if (!isDisabled && min) {
    if ((0, _compareAsc.default)(date, min) < 0) return [true];
    if (range && (0, _compareAsc.default)(date, (0, _addSeconds.default)(min, range)) > 0) return [true];
  }

  if (!isDisabled && max) {
    if ((0, _compareAsc.default)(date, max) > 0) return [true];
    if (range && (0, _compareAsc.default)(date, (0, _addSeconds.default)(max, -range)) < 0) return [true];
  }

  return [false, date];
}

function getFormat(fo) {
  var defaultFormat = 'yyyy-MM-dd HH:mm:ss.SSS';
  ['H', 'm', 's', 'S', 'h'].map(function (v) {
    if (fo.indexOf(v) <= -1) {
      var reg = new RegExp("" + v, 'g');
      defaultFormat = defaultFormat.replace(reg, '0');
    }

    return v;
  });
  return defaultFormat;
}

function resetTimeByFormat(value, fo) {
  if (!value) return null;
  var date = null;

  if (typeof value === 'string') {
    date = new Date(value);
  } else {
    date = new Date(value.getTime());
  }

  return new Date((0, _format.default)(date, getFormat(fo), {
    weekStartsOn: (0, _locale.getLocale)('startOfWeek')
  }));
}

function formatted(date, fmt) {
  if (typeof fmt === 'function') return fmt(date);

  for (var _len2 = arguments.length, options = new Array(_len2 > 2 ? _len2 - 2 : 0), _key2 = 2; _key2 < _len2; _key2++) {
    options[_key2 - 2] = arguments[_key2];
  }

  return _format.default.apply(void 0, [date, fmt].concat(options));
}

var handleOnChangeParams = function handleOnChangeParams(type) {
  return function (date, change, blur, isEnd, isQuickSelect) {
    if (blur === void 0) {
      blur = undefined;
    }

    if (isEnd === void 0) {
      isEnd = undefined;
    }

    if (isQuickSelect === void 0) {
      isQuickSelect = undefined;
    }

    return [date, change, blur, isEnd, isQuickSelect, type];
  };
};

var yearHandleChangeParams = handleOnChangeParams('year');
var monthHandleChangeParams = handleOnChangeParams('month');
var dayHandleChangeParams = handleOnChangeParams('day');
var weekHandleChangeParams = handleOnChangeParams('week');
var timeHandleChangeParams = handleOnChangeParams('time');
var quickHandleChangeParams = handleOnChangeParams('quick');
var _default = {
  clearHMS: clearHMS,
  addDays: _addDays.default,
  addMonths: _addMonths.default,
  addYears: _addYears.default,
  addSeconds: _addSeconds.default,
  cloneTime: cloneTime,
  compareAsc: _compareAsc.default,
  compareMonth: compareMonth,
  getDaysOfMonth: getDaysOfMonth,
  format: formatted,
  isInvalid: isInvalid,
  isSameDay: _isSameDay.default,
  isSameMonth: _isSameMonth.default,
  isSameWeek: _isSameWeek.default,
  isValid: _isValid.default,
  newDate: newDate,
  setTime: setTime,
  parse: _parse.default,
  toDate: _toDate.default,
  toDateWithFormat: toDateWithFormat,
  formatDateWithDefaultTime: formatDateWithDefaultTime,
  compareDateArray: compareDateArray,
  TIME_FORMAT: TIME_FORMAT,
  judgeTimeByRange: judgeTimeByRange,
  resetTimeByFormat: resetTimeByFormat,
  handleOnChangeParams: handleOnChangeParams,
  yearHandleChangeParams: yearHandleChangeParams,
  monthHandleChangeParams: monthHandleChangeParams,
  dayHandleChangeParams: dayHandleChangeParams,
  timeHandleChangeParams: timeHandleChangeParams,
  quickHandleChangeParams: quickHandleChangeParams,
  weekHandleChangeParams: weekHandleChangeParams
};
exports.default = _default;